module.exports = __webpack_public_path__ + "static/img/matrix.0482bda5.png";